import { Injectable } from "@angular/core";

@Injectable({
    providedIn:'root'
})

export class StorageService{

    storageSet(key:string, valor:unknown){
        const serializado = typeof valor === 'string' ? valor : JSON.stringify(valor);
        localStorage.setItem(key, serializado);
    }

    storageGet<T = unknown>(key:string): T | undefined {
        const json = localStorage.getItem(key);
        if (json == null || json === '') {
            return undefined;
        }

        try {
            return JSON.parse(json) as T;
        } catch {
            return undefined;
        }
    }

    storageRemove(key:string){
        localStorage.removeItem(key)
    }

    storageClear(){
        localStorage.clear()
    }

}
